module.exports = __webpack_public_path__ + "web-audio-player.2973fcacad72a0ba5b072014dbf4bc2a.swf";